import { z } from "zod";


 export const AccountGroup = z.object({
  accountGroupId: z.number(),
  accountGroupName: z.string(),
  isDefault: z.number(),
  parentGroup: z.string(),
});

 
interface ParentGroupVoType {
  accountGroupId: number;
  accountGroupName: string | null;
  groupType: string;
  parentGroupVo: ParentGroupVoType | null; // Recursive type
  groupNature: string;
  isDeleted: number;
  isDefault: number;
  level: number;
  companyId: number;
  branchId: number;
  alterBy: number;
  createdBy: number;
  createdOn: string;
  modifiedOn: string;
}

const ParentGroupVo: z.ZodType<ParentGroupVoType> = z.lazy(() =>
  z.object({
    accountGroupId: z.number(),
    accountGroupName: z.string().nullable(),
    groupType: z.string(),
    parentGroupVo: ParentGroupVo.nullable(), // Recursive reference
    groupNature: z.string(),
    isDeleted: z.number(),
    isDefault: z.number(),
    level: z.number(),
    companyId: z.number(),
    branchId: z.number(),
    alterBy: z.number(),
    createdBy: z.number(),
    createdOn: z.string(),
    modifiedOn: z.string(),
  })
);


export const CountryListAaray = z.array(
  z.object({
    countriesId: z.number(),
    countriesCode: z.string(),
    countriesName: z.string(),
    currencyCode: z.string().nullable(),
    currencyName: z.string().nullable(),
    currencySymbol: z.string().nullable(),
    isbrnrequired: z.number(),
    countryDialCodePrefix: z.number(),
    countryImageName: z.string(),
  })
);

export const CountryList = z.object({
  countriesId: z.number(),
  countriesCode: z.string(),
  countriesName: z.string(),
  currencyCode: z.string().nullable(),
  currencyName: z.string().nullable(),
  currencySymbol: z.string().nullable(),
  isbrnrequired: z.number(),
  countryDialCodePrefix: z.number(),
  countryImageName: z.string(),
})


export const StateListArrayOfObject = z.array(
  z.object({
    countriesCode: z.string().nullable(),
    stateCode: z.string().nullable(),
    stateName: z.string(),
    wooCommerceStateCode: z.string().nullable(),
    zoneCode: z.string().nullable(),
  })
);

export const StateList = z.object({
  countriesCode: z.string().nullable(),
  stateCode: z.string().nullable(),
  stateName: z.string(),
  wooCommerceStateCode: z.string().nullable(),
  zoneCode: z.string().nullable(),
});

export const CityListArrayOfObject = z.array(
  z.object({
    cityCode: z.string().nullable(),
    cityId: z.number().int(),
    cityName: z.string().nullable(),
    countriesCode: z.string().nullable(),
    stateCode: z.string().nullable(),
    zoneCode: z.string().nullable(),
  })
);

export const CityList = z.object({
  cityCode: z.string().nullable(),
  cityId: z.number().int(),
  cityName: z.string().nullable(),
  countriesCode: z.string().nullable(),
  stateCode: z.string().nullable(),
  zoneCode: z.string().nullable(),
});
const ContactAddressVoSchema = z.object({
  contactAddressId: z.number(),
  contactCompanyName: z.string().nullable(),
  countryDialCodePrefix : z.number().nullable(),
  addressType: z.string().nullable(),
  contactFirstName: z.string().nullable(),
  contactLastName: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  countriesCode: z.string(),
  zoneCode: z.string().nullable(),
  stateCode: z.string(),
  cityCode: z.string(),
  place: z.string().nullable(),
  lat: z.number(),
  lng: z.number(),
  pinCode: z.string().nullable(),
  phoneNo: z.string().nullable(),
  email: z.string().nullable(),
  isDefault: z.number(),
  GSTIN: z.string().nullable(),
  gstType: z.string().nullable(),
  panNo: z.string().nullable(),

});
 
const ContactDetailSchema = z.object({
  contactId: z.number(),
  companyName: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  mobNo: z.string().nullable(),
  telephone: z.string().nullable(),
  email: z.string().nullable(),
  dateOfBirth: z.string().nullable(),
  anniversaryDate: z.string().nullable(),
  GSTIN: z.string().nullable(),
  transporterId: z.string().nullable(),
  customerCategoryId: z.number().nullable(),
  customerCategoryName: z.string().nullable(),
  membershipId: z.number().nullable(),
  panNo: z.string().nullable(),
  tanNo: z.string().nullable(),
  vatNo: z.string().nullable().optional(),
  bankAcNo: z.string().nullable(),
  bankName: z.string().nullable(),
  bankBranch: z.string().nullable(),
  bankIfsc: z.string().nullable(),
  contactType: z.string().nullable(),
  type: z.string(),
  accountCustomId: z.number().nullable(),
  branchId: z.number().nullable(),
  companyId: z.number().nullable(),
  gstType: z.string().nullable().optional(),
  credit: z.number().nullable(),
  debit: z.number().nullable(),
  contactAddress: z.array(ContactAddressVoSchema),
  paymentMasterVo: z.any().nullable(),
  memberShipMasterVo: z.any().nullable(),
  whatsappNo: z.string().nullable(),
  remark: z.string().nullable(),
  code: z.string().nullable().optional(),
  supplierCode: z.string().nullable().optional(),
  walletBalance: z.number().nullable(),
  commission: z.number().nullable(),
  paymentTermId: z.number().optional().nullable(),
  paymentTermName : z.string().optional().nullable(),
  isdefault: z.number().nullable(),
  isBranch: z.number().nullable(),
  accountGroupId: z.number(),
  isMobNoVerify: z.number().nullable(),
  accountGroupName: z.string().nullable(),
  countryDialCodePrefix: z.number().nullable(),
  countryDialCodePrefixWhatsapp: z.number().nullable(),

  pan: z.string().nullable(),

  name: z.string().nullable(),

});
const Allowb2b = z.object({
  addValue: z.boolean().nullable(),
  branchId: z.number(),
  companyId: z.number(),
  companySettingId: z.number(),
  lastSynced: z.string().nullable(),
  type: z.string().nullable(),
  userId: z.number(),
  value: z.number(),
});
export const customerCategoryList = z.object({

  customerCategoryName: z.string().nullable(),
  customerCategoryId: z.number().nullable(),
  });
export const MembershipSchema = z.object({

  membershipId: z.number(),
  membershipName: z.string(), // Non-nullable string
});
export const PaymentTermSchema = z.object({
 
  paymentTermDay: z.string(),
  paymentTermId: z.string(),
  paymentTermName: z.string(),
});

export const ContactEditSchema = z.object({
  AccountGroupData: z.array(AccountGroup).optional().nullable() ,
  ContactDetails: ContactDetailSchema.optional(),
 

  "View-Name": z.string().optional(),
  allowb2b: z.number().optional().nullable(),
  gstverifyoption: z.number().optional().nullable(),
  allowcustomerwiseproductmapping: Allowb2b.optional(),
  allowsupplierwiseproductmapping: Allowb2b.optional(),
  customerCategoryList: z.array(customerCategoryList).optional(),
  displayContactType: z.string().optional(),
  "isEdit_customers": z.number().optional(),
  "isEdit_suppliers": z.number().optional(),
  "isEdit_transport": z.number().optional(),
  "isInsert_customers": z.number().optional(),
  "isInsert_suppliers": z.number().optional(),
  "isInsert_transport": z.number().optional(),
  membership: z.number().optional().nullable(),
  membershiplist: z.array(MembershipSchema).optional(),
  multibarcode: Allowb2b.optional(),
  multiduplicatebarcode: Allowb2b.optional(),
  paymentTermList: z.array(PaymentTermSchema).optional(),
 
  type : z.string().optional(),
  typeOfContact: z.string().optional(),
  viewname : z.string().nullable().optional()
  
});

export type MembershipSchemas = z.infer<typeof MembershipSchema>;
export type CustomerCategoryList = z.infer<typeof customerCategoryList>;
export type PaymentTermSchemas = z.infer<typeof PaymentTermSchema>;
export type AccountGroups = z.infer<typeof AccountGroup>;
export type CountryAarayList = z.infer<typeof CountryListAaray>;
export type CountryLists = z.infer<typeof CountryList>;
export type StateList = z.infer<typeof StateList>;
export type CityList = z.infer<typeof CityList>;
export type ContactEditType = z.infer<typeof ContactEditSchema>;